import * as service from './service'
export default {
  namespace: 'SuppliersList',
  state: {
    list: []
  },
  effects: {
    * list ({ payload }, { call, put }) {
      const res = yield call(service.list, payload)
      yield put({
        type: 'save',
        payload: {
          list: res.data.data || {}
        }
      })
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
